import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { ToastContainer } from './components/common';
import { useAuthStore } from './stores/authStore';
import { authApi } from './services/api';

/**
 * Root application component.
 * Sets up routing and global providers.
 * Validates persisted session on mount.
 */
function App() {
  const { isAuthenticated, setLoading, setAdmin, logout } = useAuthStore();

  // Validate session on app mount
  useEffect(() => {
    const validateSession = async () => {
      // If we have a persisted session, validate it with the server
      if (isAuthenticated) {
        try {
          const user = await authApi.me();
          // Session is valid, update admin info
          setAdmin({
            id: user.id,
            email: user.email,
            role: user.role,
            lastLoginAt: user.lastLoginAt,
          });
        } catch {
          // Session is invalid, clear auth state
          logout();
        }
      }
      // Always set loading to false after check
      setLoading(false);
    };

    validateSession();
  }, [isAuthenticated, logout, setAdmin, setLoading]);

  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
